import React from 'react';

interface LogoProps {
  /** Size of the logo: 'sm', 'md', or 'lg' */
  size?: 'sm' | 'md' | 'lg';
  /** Additional CSS classes to apply */
  className?: string;
}

/**
 * Andersens Logo Component
 * 
 * Displays the Andersens logo using the official PNG logo file.
 * 
 * @example
 * ```tsx
 * // Basic usage
 * <Logo />
 * 
 * // Large logo
 * <Logo size="lg" />
 * 
 * // Small logo
 * <Logo size="sm" />
 * ```
 */
export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: {
      container: 'flex items-center rounded-lg p-2',
      logo: 'h-8 w-auto',
    },
    md: {
      container: 'flex items-center rounded-lg p-3',
      logo: 'h-10 w-auto',
    },
    lg: {
      container: 'flex items-center rounded-lg p-4',
      logo: 'h-14 w-auto',
    },
  };

  const currentSize = sizeClasses[size];

  return (
    <div className={`${currentSize.container} ${className}`}>
      {/* PNG Logo - includes text and tagline */}
      <img 
        src="/andersens_logo.png" 
        alt="Andersens Logo" 
        className={currentSize.logo}
      />
    </div>
  );
}; 